import { api } from './api';

export interface DealStage {
  workspaceId: string;
  key: string;
  label: string;
  position: number;
  isWon: boolean;
  isLost: boolean;
}

export interface Deal {
  id: string;
  workspaceId: string;
  accountId: string;
  primaryContactId: string | null;
  name: string;
  stage: string;
  amountCents: number | null;
  currency: string;
  probability: number | null;
  expectedClose: string | null;
  closedAt: string | null;
  outcome: string | null;
  ownerUserId: string | null;
  healthScore: number | null;
  nextBestAction: string | null;
  createdAt: string;
  updatedAt: string;
}

export const dealsApi = {
  stages: async (workspaceId: string) => {
    const r = await api.get<DealStage[]>('/api/deal-stages', { params: { workspaceId } });
    return r.data;
  },
  seedDefaultStages: async (workspaceId: string) => {
    const r = await api.post<DealStage[]>('/api/deal-stages/seed-defaults', { workspaceId });
    return r.data;
  },
  createStage: async (input: {
    workspaceId: string;
    key: string;
    label: string;
    position: number;
    isWon?: boolean;
    isLost?: boolean;
  }) => {
    const r = await api.post<DealStage>('/api/deal-stages', input);
    return r.data;
  },
  deleteStage: async (workspaceId: string, key: string) => {
    await api.delete(`/api/deal-stages/${encodeURIComponent(key)}`, { params: { workspaceId } });
  },
  list: async (params: { workspaceId: string; stage?: string; ownerId?: string; limit?: number; offset?: number }) => {
    const r = await api.get<{ items: Deal[]; total: number }>('/api/deals', { params });
    return r.data;
  },
  pipeline: async (workspaceId: string) => {
    const r = await api.get<{
      stages: DealStage[];
      buckets: Record<string, { count: number; totalAmountCents: number; deals: Deal[] }>;
    }>('/api/deals/pipeline', { params: { workspaceId } });
    return r.data;
  },
  create: async (input: Partial<Deal> & { workspaceId: string; accountId: string; name: string; stage: string }) => {
    const r = await api.post<Deal>('/api/deals', input);
    return r.data;
  },
  update: async (id: string, patch: Partial<Deal>) => {
    const r = await api.patch<Deal>(`/api/deals/${id}`, patch);
    return r.data;
  },
};
